import React, { useState } from "react";

const SOURCE_COLOR = {
  "CoinDesk":        "#f59e0b",
  "CoinTelegraph":   "#3b82f6",
  "Decrypt":         "#a855f7",
  "Bitcoin Magazine":"#f97316",
  "The Block":       "#22c55e",
};

export default function NewsPanel({ data }) {
  const [filter, setFilter] = useState("all");
  if (!data?.items?.length) return (
    <p style={{ color:"#6b7280", fontSize:12 }}>뉴스 로딩 중... (첫 로드 시 30초 소요)</p>
  );

  const items = filter === "high"
    ? data.items.filter(n => n.importance === "high")
    : data.items;

  return (
    <div>
      {/* 필터 + 소스 범례 */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
        <div style={{ display:"flex", gap:6 }}>
          {[["all","전체"], ["high","중요"]].map(([v, l]) => (
            <button key={v} onClick={() => setFilter(v)} style={{
              background: filter===v ? "#3b82f6" : "#181c24",
              color:      filter===v ? "#fff"     : "#6b7280",
              border:"none", borderRadius:6, padding:"4px 12px",
              fontSize:12, fontWeight:600, cursor:"pointer",
            }}>{l}</button>
          ))}
        </div>
        <span style={{ fontSize:11, color:"#4b5563" }}>
          {data.items.filter(x => x.importance==="high").length}개 중요
        </span>
      </div>

      {/* 뉴스 리스트 */}
      <div style={{ display:"flex", flexDirection:"column", gap:7, maxHeight:420, overflowY:"auto" }}>
        {items.map((item, i) => {
          const srcColor = SOURCE_COLOR[item.source] || "#6b7280";
          return (
            <a key={i} href={item.url} target="_blank" rel="noopener noreferrer"
              style={{ textDecoration:"none", color:"inherit" }}>
              <div style={{
                padding:"9px 12px", background:"#181c24", borderRadius:8,
                border:`1px solid ${item.importance==="high" ? "rgba(239,68,68,.3)" : "#1e2433"}`,
                transition:"border-color .15s",
              }}
                onMouseEnter={e => e.currentTarget.style.borderColor="#3b82f6"}
                onMouseLeave={e => e.currentTarget.style.borderColor=item.importance==="high"?"rgba(239,68,68,.3)":"#1e2433"}
              >
                <p style={{ fontSize:13, fontWeight:600, lineHeight:1.4, marginBottom:5 }}>
                  {item.importance === "high" && <span style={{ color:"#ef4444", marginRight:4 }}>🔴</span>}
                  {item.title}
                </p>
                <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                  <span style={{
                    fontSize:11, padding:"1px 7px", borderRadius:4, fontWeight:600,
                    color: srcColor,
                    background: `${srcColor}18`,
                  }}>{item.source}</span>
                  {item.published_at && (
                    <span style={{ fontSize:11, color:"#4b5563" }}>
                      {_formatDate(item.published_at)}
                    </span>
                  )}
                </div>
              </div>
            </a>
          );
        })}
      </div>

      {data.updated_at && (
        <p style={{ fontSize:11, color:"#374151", marginTop:8 }}>업데이트: {data.updated_at}</p>
      )}
    </div>
  );
}

function _formatDate(dateStr) {
  if (!dateStr) return "";
  try {
    const d = new Date(dateStr);
    const now = new Date();
    const diffH = Math.floor((now - d) / 3600000);
    if (diffH < 1) return "방금 전";
    if (diffH < 24) return `${diffH}시간 전`;
    return `${Math.floor(diffH/24)}일 전`;
  } catch { return ""; }
}
